import axios from 'axios';

export class AxiosTimeoutClassifier {
  static isTimeout(error: unknown): boolean {
    // Axios browser timeout: code=ECONNABORTED + message includes "timeout"
    if (axios.isAxiosError(error)) {
      const code = (error as any)?.code;
      const message = (error as any)?.message as string | undefined;
      const status = error.response?.status;

      if (code === 'ECONNABORTED') return true;
      if (typeof message === 'string' && message.toLowerCase().includes('timeout')) return true;
      if (status === 504) return true; // gateway timeout
    }

    // Fetch aborts (in case any call site switches away from axios)
    if (typeof error === 'object' && error !== null) {
      const name = (error as any).name as string | undefined;
      if (name === 'AbortError') return true;
    }

    return false;
  }
}

